import { gsap } from "gsap";
import jQuery, { data } from "jquery";
import { PageHandler } from './PageHandler';
import moment from "moment";

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export class PVOutputPageHandler extends PageHandler {
	constructor(id) {
		super(id);
		this.fields = {};
		this.latlngChanged = false;
	}

	showError(text) {
		jQuery('.form-status').text(text);
		jQuery('.form-status').addClass('error')
	}

	hideError() {
		jQuery('.form-status').text('');
		jQuery('.form-status').removeClass('error')
	}

	ajax() {

	}

	events() {
		var _this = this;
		/* Tab selection */
		jQuery('body').on('click', '.section__pv-output-tab:not(.active):not(.disabled)', function() {
			var view = jQuery(this).data('tab')
			jQuery('.section__pv-output-tab.active').removeClass('active')
			jQuery(this).addClass('active')
			_this.changeTab(view);
		})

		const numInputs = document.querySelectorAll('input[type=number][required]')

		numInputs.forEach(function(input) {
			const def = input.setAttribute('data-default', input.value);
			input.addEventListener('input', function(e) {
				if (e.target.value == '') {
					e.target.value = input.getAttribute('data-default');

				}
			})
		})
	}

	/* Updates CSS variables related to the illustration, according to the field values */
	updateIllustrationParameters() {
		var r = document.querySelector(':root');
		r.style.setProperty('--illustration-beta', document.querySelector('#input-tilt').value + 'deg');
		r.style.setProperty('--illustration-theta', document.querySelector('#input-basic-theta').value + 'deg');
		r.style.setProperty('--illustration-L', document.querySelector('#input-basic-L').value * 4 + 'px');
		r.style.setProperty('--illustration-K', document.querySelector('#input-basic-K').value * 4 + 'px');
		r.style.setProperty('--illustration-H', document.querySelector('#input-basic-height').value * 2.5 + 'px');
	}

	/* Updates the illustration according to the CSS variables */
	updateIllustrationLines() {
		const line = document.querySelector('.panel-illustration__Bground-line');
		const beta2 = document.querySelector('.panel-illustration__label.panel-illustration__label--beta-2');
		const panelBC = document.querySelector('.panel-illustration__BC-line');
		const panelAD = document.querySelector('.panel-illustration__AD-line');
		const panelShadow = document.querySelector('.panel-illustration__CD-line');
		const panelStraight = document.querySelector('.panel-illustration__beta-line');
		const L = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-L'));
		const H = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-H'));
		const beta = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-beta'));
		const theta = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-theta'));
		// const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-offset'));
		const groundHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-ground-height'));
		const triangleOpp = H + L * Math.sin((beta * Math.PI) / 180);
		const W = H / Math.tan(beta * (Math.PI / 180));
		const diagonal = Math.sqrt(H * H + W * W);
		const BCwidth = H / Math.cos((beta * Math.PI) / 180);
		const ADwidth = triangleOpp / Math.sin((theta) * (Math.PI / 180));

		const tempEl = document.createElement('div');
		tempEl.style.position = 'absolute';
		tempEl.style.visibility = 'hidden';
		tempEl.style.height = 'var(--illustration-offset)'; // apply the variable
		document.body.appendChild(tempEl);

		// Get the resolved height in pixels
		const offset = parseFloat(getComputedStyle(tempEl).height);
		document.body.removeChild(tempEl);

		function getBDx(AB, CD, dist, angleAdeg, angleCdeg) {
			const degToRad = deg => deg * Math.PI / 180;

			const Xa = 0;      // A at (0, H)
			const Xc = dist;    // C at (100, H)

			const angleA = degToRad(angleAdeg);
			const angleC = degToRad(angleCdeg);

			const Bx = Xa + AB * Math.cos(angleA);
			const Dx = Xc + CD * Math.cos(angleC);

			const BDx = Dx - Bx;
			return BDx;
		}

		if (beta <= 0 || beta > 90)
			line.style.display = 'none';
		else
			line.style.display = 'block';

		line.style.width = `${diagonal + 2}px`;
		line.style.left = `${177 + offset - W}px`;

		panelStraight.style.width = `${L * Math.cos((beta * Math.PI) / 180)}px`;
		beta2.style.left = `${((210 + offset - W) > 0) ? (210 + offset - W) : 0}px`;

		panelBC.style.transform = `rotate(${90 - beta}deg)`;
		panelBC.style.width = `${BCwidth}px`;
		const CD = getBDx(BCwidth, ADwidth, L * Math.cos((beta * Math.PI) / 180), 90 - beta, theta);

		panelShadow.style.width = `${CD}px`;
		panelShadow.style.left = `${180 + offset + H*Math.tan((beta * Math.PI) / 180)}px`;

		panelAD.style.left = `${180 + offset + L * Math.cos((beta * Math.PI) / 180)}px`;
		panelAD.style.bottom = `${groundHeight + triangleOpp}px`;
		panelAD.style.transform = `rotate(${theta}deg)`;
		panelAD.style.width = `${ADwidth}px`;
	}

	transitions() {
		
	}

	/* Sends an AJAX request to autocomplete the city */
	doAjaxCheckCity(callback) {
		var _this = this;
		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'query': _this.fields.cityQuery,
				'action': 'checkcity',
				'_ajax_nonce_checkcity': bipv_script_data.nonce_checkcity
			},
			success: function(response) {
				// console.log(response)
				if (response.success)
				{
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	/* Sends the AJAX request for BIPV design (climate and PV) */
	doAjaxBIPVDesign(callback) {
		var _this = this;
		gsap.set('.section__pv-output-right .return-results-container.ti-results .loading-screen', {autoAlpha: 1})
		gsap.set('.section__pv-output-right .return-results-container.pvo-results', {display: 'none'})

		let drs = '1', dre = '1';
		if (window.tiMethod == "pvgis")
		{
			drs = _this.fields.dateRangeStart.format('DD/MM/YYYY')
			dre = _this.fields.dateRangeEnd.format('DD/MM/YYYY')
		}
		else if (window.tiMethod != "pvgis-tmy")
		{
			drs = _this.fields.dateRangeStart.format('MM/DD/YYYY')
			dre = _this.fields.dateRangeEnd.format('MM/DD/YYYY')
		}

		/* Basic data object */
		var dataobj = {
			'tilt': _this.fields.tilt,
			'azimuth': _this.fields.azimuth,
			'dateRangeStart': drs,
			'dateRangeEnd': dre,
			'action': 'pvlib',
			'method': window.tiMethod,
			'doPVOutput': false,
			'_ajax_nonce_pvlib': bipv_script_data.nonce_pvlib
		};

		if (window.tiMethod != "epw")
		{
			dataobj['lat'] = _this.fields.latitude;
			dataobj['lng'] = _this.fields.longitude;
			dataobj['altitude'] = _this.fields.altitude;
		}
		else // EPW mode simply requires the location
			dataobj['location'] = _this.fields.epwLocation;

		if (window.selectedDatabase)
			dataobj['database'] = window.selectedDatabase;

		/* Add PV Output parameters */
		if (jQuery('form.pv-output-form #do-pvoutput').is(':checked'))
		{
			Object.assign(dataobj, {
				doPVOutput: true,
				pvo_param_IL: jQuery('form.pv-output-form input[name="pv-IL"]').val(),
				pvo_param_I0: jQuery('form.pv-output-form input[name="pv-I0"]').val(),
				pvo_param_RS: jQuery('form.pv-output-form input[name="pv-RS"]').val(),
				pvo_param_Rsh: jQuery('form.pv-output-form input[name="pv-Rsh"]').val(),
				pvo_param_n: jQuery('form.pv-output-form input[name="pv-n"]').val(),
				pvo_param_ns: jQuery('form.pv-output-form input[name="pv-ns"]').val()
			})

			gsap.set('.section__pv-output-right .return-results-container.pvo-results', {display: 'block'})
			gsap.set('.section__pv-output-right .return-results-container.pvo-results .loading-screen', {autoAlpha: 1})
		}

		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: dataobj,
			success: function(response) {
				if (response.success)
				{
					gsap.set('.section__pv-output-right .loading-screen', {autoAlpha: 0})
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	
	formCity() {
		const cache = new Map();
		let debounceTimeout;
		const input = document.getElementById("input-city");
        const suggestions = document.getElementById("suggestions");
        const output = document.getElementById("output");
		var _this = this;

		function displaySuggestions(data) {
			suggestions.innerHTML = "";
			if (data.length > 0) {
				suggestions.style.display = "block";
				data.forEach(location => {
					const div = document.createElement("div");
					div.classList.add("suggestion-item");
					div.textContent = location.city;
					div.addEventListener("click", () => {
						input.value = location.city;
						suggestions.style.display = "none";
						setCoordinates(location);
					});
					suggestions.appendChild(div);
				});
			} else {
				suggestions.style.display = "none";
			}
		}

		function fetchSuggestions() {
			clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(() => {
				_this.fields.cityQuery = input.value.trim();
				if (!_this.fields.cityQuery) {
					suggestions.style.display = "none";
					return;
				}
				
				if (cache.has(_this.fields.cityQuery)) {
					displaySuggestions(cache.get(_this.fields.cityQuery));
					return;
				}
				_this.doAjaxCheckCity((data) => {
					cache.set(_this.fields.cityQuery, data); // Store results in cache
					displaySuggestions(data);
				});
				
			}, 600);
		}

		function setCoordinates(location) 
		{
            jQuery('#input-latitude').val(location.lat);
            jQuery('#input-longitude').val(location.lng);
			jQuery('.update-map').trigger('click');
        }

        input.addEventListener("input", fetchSuggestions);
        document.addEventListener("click", (e) => {
            if (!input.contains(e.target) && !suggestions.contains(e.target))
                suggestions.style.display = "none";
        });
	}
	
	formLocation() {
        var _this = this;
		if (this.map)
			this.map.remove();

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		this.map.setView([37.9708454, 23.722982], 13);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
        
        var marker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false}).addTo(this.map);
        
        function updateLatLng() {
            var center = _this.map.getCenter();
            marker.setLatLng(center);
           	jQuery('form.pv-output-form input[name="latitude"]').val(center.lat.toFixed(6));
           	jQuery('form.pv-output-form input[name="longitude"]').val(center.lng.toFixed(6));

			_this.fields.latitude = center.lat.toFixed(6);
			_this.fields.longitude = center.lng.toFixed(6);
			_this.fields.altitude = 100;
        }
        
        this.map.on('move', updateLatLng);
        updateLatLng();

		jQuery('form.pv-output-form input[name="latitude"], form.pv-output-form input[name="longitude"]').on('input', function() {
			_this.latlngChanged = true;
		})
		
		jQuery(document).on("keypress", 'form.pv-output-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});

		jQuery('form.pv-output-form button.update-map').on('click', function() {
			if (_this.latlngChanged)
			{
				jQuery('#input-city').val('');
				_this.latlngChanged = false;
			}
			_this.map.setView([
				parseFloat(jQuery('form.pv-output-form input[name="latitude"]').val()), 
				parseFloat(jQuery('form.pv-output-form input[name="longitude"]').val())], 
			_this.map.getZoom());
		})
	}

	
	formLocation_EPW(lat, lng, alt) {
		var _this = this;
		if (this.map)
			this.map.remove();

		function updateLatLng_EPW(lat, lng, alt) {
			_this.map.setView([lat, lng], 13);
			var center = _this.map.getCenter();
			_this.mapMarker.setLatLng(center);
			jQuery('form.pv-output-form input[name="latitude"]').val(center.lat.toFixed(6));
			jQuery('form.pv-output-form input[name="longitude"]').val(center.lng.toFixed(6));
			jQuery('form.pv-output-form input[name="altitude"]').val(alt);

			_this.fields.latitude = center.lat.toFixed(6);
			_this.fields.longitude = center.lng.toFixed(6);
			_this.fields.altitude = alt;
		}

		const locationForm = document.querySelector('.pv-output-form');
		const selectedLoc = document.querySelector('main.pv-output .section__settings--location .same-as-selected')

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
		this.map.setView([lat, lng], 13);
        this.mapMarker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false}).addTo(this.map);
        updateLatLng_EPW(lat, lng, alt);
		
		jQuery(document).on("keypress", 'form.pv-output-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});

		window.selectedLocation = selectedLoc.getAttribute('data-value');
		locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
		window.global.initSelect('main.pv-output .section__settings--location .custom-select-wrapper', (option) => {
			window.selectedLocation = jQuery(option).data('value');
			let lat = jQuery(option).data('lat')
			let lng = jQuery(option).data('lng')
			let alt = jQuery(option).data('alt')

			locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
			updateLatLng_EPW(lat, lng, alt);
		});
	}

	formDateRange() {
		var _this = this;
		jQuery('#graph-daterange').daterangepicker({
			showDropdowns: true,
			autoApply: true,
			locale: { format: "DD/MM/YYYY" },
			startDate: window.tiMethod == "pvgis" ? "01/01/2023" : moment().format('DD/MM/YYYY'),
			minDate: window.tiMethod == "pvgis" ? "01/01/2005" : `01/01/1970`,
			maxDate: window.tiMethod == "pvgis" ? "31/12/2023" : moment().format('DD/MM/YYYY')
		}, function(start, end, label) {
			_this.fields.dateRangeStart = start;
			_this.fields.dateRangeEnd = end;
		});

		_this.fields.dateRangeStart = jQuery('#graph-daterange').data('daterangepicker').startDate;
		_this.fields.dateRangeEnd = jQuery('#graph-daterange').data('daterangepicker').endDate;
	}

	/* Creates a table from the parsed data */
	createTable(parsedData, tableID, parent) {
		window.tableRows = parsedData.data;
		window.tableIndexes = parsedData.index;
		let header = ['Datetime'];

		const thead = document.createElement("thead"), 
		      theadRow = document.createElement("tr"),
		      tbody = document.createElement("tbody");
		const table = document.getElementById(tableID);
		
		parsedData.index = parsedData.index.map((element) => {
			const opts = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
			return moment.utc(element).format('DD/MM/YYYY, HH:mm');
		})

		if (parsedData.columns && parsedData.columns.length > 0)
		{
			header = Array.prototype.concat(header, parsedData.columns);
			header.forEach(element => {
				const th = document.createElement("th");
				th.textContent = element;
				theadRow.appendChild(th);
			});
			thead.appendChild(theadRow);
		}
		else if (parsedData.name)
		{
			header.push(parsedData.name);
			header.forEach(element => {
				const th = document.createElement("th");
				th.textContent = element;
				theadRow.appendChild(th);
			});
			thead.appendChild(theadRow);
		}
		
		table.appendChild(thead);
		table.appendChild(tbody);

		/* Chunk loading */
		let loadedLines = 0;
		const CHUNK_SIZE = 19; 
		parent.scrollTop = 0;
		jQuery(parent).off('scroll')

		const merged = parsedData.data.map((row, i) => {
			const values = Array.isArray(row) ? row : [row];
			return [parsedData.index[i], ...values];
		});

		function loadChunk() {
			if (loadedLines < merged.length) {
				const nextChunk = merged.slice(loadedLines, loadedLines + CHUNK_SIZE);

				nextChunk.forEach(row => {
					const tr = document.createElement("tr");
					row.forEach(cell => {
						const td = document.createElement("td");
						td.textContent = cell;
						tr.appendChild(td);
					});
					tbody.appendChild(tr);
				});
		
				loadedLines += CHUNK_SIZE;
			}
		}
	
		loadChunk();
		
		jQuery(parent).on('scroll', () => {
			const scrollHeight = parent.scrollHeight;
			const scrollTop = parent.scrollTop;
			const clientHeight = parent.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight - 100) {
				loadChunk();
			}
		});
	}

	
	async calculate({ useEPW = false }) {
		const form = jQuery('form.pv-output-form');
		this.fields.tilt = form.find('input[name="tilt"]').val();
		this.fields.azimuth = form.find('input[name="azimuth"]').val();

		if (useEPW) 
		{
			this.fields.epwLocation = form.find('input[name="location"]').val();
			jQuery('#pv-output-table').empty(); // Only clear if EPW (no PV output table)
		} 
		else 
		{
			// Fetch altitude from Open-Meteo
			const { latitude, longitude } = this.fields;
			try {
				const response = await fetch(`https://api.open-meteo.com/v1/elevation?latitude=${latitude}&longitude=${longitude}`);
				const data = await response.json();
				this.fields.altitude = data.elevation[0].toFixed(2);
			} catch (error) {
				console.error('Error fetching altitude:', error);
				this.fields.altitude = 100;
			}
			form.find('input[name="altitude"]').val(this.fields.altitude);
		}

		/* Preparations */
		document.getElementById("csv-table").innerHTML = "";
		document.getElementById("pv-output-table").innerHTML = "";
		gsap.to('.section__pv-output-right', { autoAlpha: 1, display: "block" });

		if (jQuery('form.pv-output-form #do-pvoutput').is(':checked')) 
			gsap.set('.pvoutput-heading, .pvo-results', { display: 'block' });
		else
			gsap.set('.pvoutput-heading, .pvo-results', { display: 'none' });

		/* AJAX + render */
		this.doAjaxBIPVDesign((data) => {
			const parsedData = JSON.parse(data);

			/* Total Irradiance */
			this.createTable(
				parsedData['total_irradiance'], 
				'csv-table', 
				document.querySelector('.return-results-container.ti-results .return-results')
			);
			this.maybeShowScrollHint('#csv-table', '.return-results-container.ti-results');

			/* PV Output */
			if (jQuery('form.pv-output-form #do-pvoutput').is(':checked')) 
			{
				this.createTable(
					parsedData['ac_power'], 
					'pv-output-table', 
					document.querySelector('.return-results-container.pvo-results .return-results')
				);
				this.maybeShowScrollHint('#pv-output-table', '.return-results-container.pvo-results');
			}
		});
	}

	maybeShowScrollHint(tableSelector, containerSelector) {
		if (jQuery(tableSelector).height() <= jQuery(containerSelector).height()) 
			return;

		const hint = `${containerSelector} .please-scroll`;
		gsap.to(hint, { autoAlpha: 0.9, duration: 0.3 });
		setTimeout(() => {
			gsap.to(hint, { autoAlpha: 0, duration: 0.3 });
		}, 2000);
	}

	formEvents() {
		window.maybe = this.maybeShowScrollHint;
		var _this = this;
		jQuery('form.pv-output-form input[type="submit"]').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			_this.calculate({ useEPW: (window.tiMethod == "epw") });
		})

		jQuery('form.pv-output-form #do-pvoutput').on('click', function(e) {
			jQuery('main.pv-output .section__settings--pv-output-parameters').toggleClass('hidden');
		})

		jQuery('main.pv-output .section__settings .tooltip').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			jQuery(this).find('.tooltip-text').toggleClass('active');
		})
	}


	initPageClearsky() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();
		this.formIllustration();
	}

	formIllustration() {
		var _this = this;

		this.updateIllustrationParameters();
		this.updateIllustrationLines();

		jQuery(`form.pv-output-form input[name="tilt"], 
			form.pv-output-form input[name="basic-L"], 
			form.pv-output-form input[name="basic-K"], 
			form.pv-output-form input[name="basic-height"],
			form.pv-output-form input[name="basic-theta"]`).on('input', function() {
			_this.updateIllustrationParameters();
			_this.updateIllustrationLines();
		})

		jQuery(window).on('resize', function() {
			_this.updateIllustrationLines();
		})
	}

	initPageEPW() {
		const selectedLoc = document.querySelector('main.pv-output .section__settings--location .same-as-selected')
		let lat = selectedLoc.getAttribute('data-lat')
		let lng = selectedLoc.getAttribute('data-lng')
		let alt = selectedLoc.getAttribute('data-alt')

		this.formLocation_EPW(lat, lng, alt);
		this.formDateRange();
		this.formEvents();
		this.formIllustration();
	}

	/* TODO implement */
	initPageEPWFile() {
		var _this = this;
	}

	initPagePVGIS() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();
		this.formIllustration();

		const database = document.querySelector('main.pv-output .section__settings--database .same-as-selected')
		window.selectedDatabase = database.getAttribute('data-value');
		window.global.initSelect('main.pv-output .section__settings--database .custom-select-wrapper', (option) => {
			window.selectedDatabase = jQuery(option).data('value');
		});
	}

	initPagePVGIS_TMY() {
		this.formCity();
		this.formLocation();
		this.formEvents();
		this.formIllustration();
	}

	init() {
		this.events();
		var _this = this;
		
		if (window.tiMethod == "epw")
			this.initPageEPW();
		else if (window.tiMethod == "pvgis")
			this.initPagePVGIS();
		else if (window.tiMethod == "pvgis-tmy")
			this.initPagePVGIS_TMY();
		else
			this.initPageClearsky();
	}


	destroy() {

	}
}
